import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Input, Button, Form } from "antd";

import './Login.css';

import { useSelector } from "react-redux";
import { isAuthenticated } from "../App";
import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import ApiService from "../Api.service";
import ApiUrls from "../ApiUrls";
import { openNotification } from "./MainLayout/Notification";
import usePageActivation from '../hooks/usePageActivation';

export function config(issuer: string, clientId: string, idpType: string, store) {
    let scopes = "openid profile email";
    switch (idpType) {
        case "AAD":
            scopes += " api://" + clientId + "/credenti.apps";
            break;
        case "CREDENTI_IDP":
            scopes += " aws.cognito.signin.user.admin";
            break;
        case "CYBERARK":
            scopes += "";
            break;
        default:
            scopes += " offline_access";
    }

    return {
        authority: issuer,
        client_id: clientId,
        // Cyberark
        // client_secret: "tecconnect",
        redirect_uri: window.location.origin + "/login/callback",
        response_type: "code",
        scope: scopes,
        post_logout_redirect_uri: window.location.origin + "/logout/callback",
        userStore: store,
    }
};

export async function getTentantScreen(email: string, account: any) {
    localStorage.setItem("clientId", account.idp_app_oidc_client_id);
    localStorage.setItem("issuer", account.issuer_url);
    localStorage.setItem("accountName", account.name);
    localStorage.setItem("idpType", account.idp_type);
    localStorage.setItem("idpRef", account.idp_ref);
    localStorage.setItem("email", email);
    if (account.issuer_url !== "" && account.idp_app_oidc_client_id !== "" && account.idp_type !== "") {
        const webStorageStore = new WebStorageStateStore({ store: window.localStorage })
        const userManager = new UserManager(config(account.issuer_url, account.idp_app_oidc_client_id, account.idp_type, webStorageStore))
        userManager.signinRedirect({
            extraQueryParams: {
                login_hint: email ? email : ""
            }
        });
    }
}

export const emailPatternValidation = (email: string): boolean => {
    const regex = new RegExp(/<(?=>)/);
    return regex.test(email);
};

export function validateEmail(email) {
    let emailPrefix = email.split('@')[0];
    let domain = email.split('@')[1];
    if (email.length === 0 || !email.includes('@') || emailPrefix === "" || domain === "" || !domain.includes('.') || domain.split('.')[0] === "" || domain.split('.')[1] === "" || emailPatternValidation(email)) {
        return false
    }
    return true
}

function Login() {
    const [email, setEmail] = useState<string>("");
    const [message, setMessage] = useState<string>("");
    const history = useHistory();
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMessage] = useState<any>('');
    const user = useSelector((state: any) => state.auth.user);

    usePageActivation(() => {
        setButtonLoading(false);
    });

    useEffect(() => {
        setButtonLoading(false);
        localStorage.removeItem("domainLogin");
        localStorage.removeItem('switch_account');
    }, [window.location.pathname]);

    const handleFormSubmit = () => {
        setButtonLoading(true);
        ApiService.post(ApiUrls.loginWithOidc, { email: email })
            .then(data => {
                if (!data.errorSummary) {
                    getTentantScreen(email, data)
                }
                else {
                    openNotification("error", data.errorCauses.length !== 0 ? data.errorCauses[0]?.errorSummary ?? data.errorCauses[0] : data.errorSummary)
                    setButtonLoading(false);
                }
            })
            .catch(e => {
                setErrorMessage("Login failed, due to Internal Server")
                setButtonLoading(false);
            })
            .finally(() => { })
    };

    function handleSubmit() {
        if (email.length === 0) {
            setShowError(false);
            setMessage("Email is required");
        } else if (!validateEmail(email)) {
            setShowError(false);
            setMessage("Please enter a valid email");
        } else {
            setMessage("");
            setShowError(false);
            handleFormSubmit();
        }
    }

    function checkInvalid(): 'success' | 'error' {
        if (!validateEmail(email) && message.length !== 0) {
            return 'error';
        }
        return 'success';
    }

    return (
        <>
            {
                user && user.access_token && isAuthenticated() ? (
                    <>{history.push('/accounts')}</>
                )
                    : (
                        <div style={{ height: '100vh', backgroundColor: 'whitesmoke' }}>
                            <div id="login-container" className="login-container-login-page">
                                <div className="login-logo">
                                    <img src={window.location.origin + '/Credenti_Logo.png'} alt="Credenti TecConnect" height={40} />
                                </div>

                                <div className="heading"><span>Account Management Portal</span></div>

                                {
                                    showError && <div style={{ color: 'rgb(232, 17, 35)', textAlign: 'left', position: 'relative', top: '23px', padding: '0 35px 0 35px' }}>
                                        {errorMsg}
                                    </div>
                                }

                                <Form onFinish={handleSubmit} layout="vertical"
                                    role="loginForm"
                                    id="login-form"
                                    style={{ textAlign: 'left', padding: '35px 35px 20px 35px' }}
                                >
                                    <Form.Item
                                        label={'Email'}
                                        validateStatus={checkInvalid()}
                                        style={{ marginBottom: '25px', fontSize: '20px' }}
                                    >
                                        <Input
                                            style={{ borderRadius: '5px' }}
                                            autoFocus
                                            name="email"
                                            role="email"
                                            onChange={(e) => { setEmail(e.target.value.split(" ").join("")) }}
                                            size="large"
                                        />
                                        <div style={{ color: 'red', textAlign: 'left', fontSize: "14px" }}>{message}</div>
                                    </Form.Item>

                                    <Form.Item style={{ marginBottom: '16px' }}>
                                        <Button
                                            type="primary"
                                            loading={buttonLoading}
                                            className="submit-button"
                                            size="large"
                                            htmlType="submit"
                                            role="nextButton"
                                        >
                                            Next
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        </div>
                    )}
        </>
    );
}

export default Login;
